import './Header.css';

import { NavLink, useNavigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { clearUserData, selectUser } from '../../redux/reducers/userReducer';
import { useDispatch, useSelector } from 'react-redux';

import { clearColumns } from '../../redux/reducers/columnReducer';
import { clearHome } from '../../redux/reducers/homeReducer';
import { clearPodcasts } from '../../redux/reducers/podcastReducer';

import LoginSignUpPopup from '../LoginSignUpPopup/LoginSignUpPopup';
import ProfileMenu from './ProfileMenu';
import { getRandomColor } from '../../helper';
import { useLoader } from '../../hooks/useLoader';

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(
    !!localStorage.getItem('user_email')
  );
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const [showProfileMenu, setShowProfileMenu] = useState<boolean>(false);
  const [showRegister, setShowRegister] = useState<boolean>(false);
  const [showHamBurgerMenu, setShowHamBurgerMenu] = useState<boolean>(false);

  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const profileMenuRef = useRef<HTMLDivElement | null>(null);
  const profileIconRef = useRef<HTMLDivElement | null>(null);
  const profileImageRef = useRef<HTMLImageElement | null>(null);

  const handleLoginClick = (showType: 'login' | 'register') => {
    setShowRegister(showType === 'register');
    setShowLogin(true);
  };

  const handleCloseModal = () => {
    setShowLogin(false);
  };

  const { showLoading } = useLoader();

  useEffect(() => {
    if (user.data?.success) {
      setIsLoggedIn(true);
      showLoading(false);
      handleCloseModal();
    }
  }, [user, showLoading]);

  const handleProfileClick = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setShowProfileMenu(false);
    navigate('/');
    dispatch(clearUserData());
    // Content caches hold user-specific data (paywalled stories, pro podcast
    // URLs) — drop them outright rather than relying on the per-slice
    // cachedForEmail guards alone.
    dispatch(clearHome());
    dispatch(clearColumns());
    dispatch(clearPodcasts());
    localStorage.removeItem('user_email');
  };

  const handleAdminConsole = () => {
    navigate('/AdminConsole');
    setShowProfileMenu(false);
  };

  const handleCancelSucription = () => {
    const isConfirmed = window.confirm(
      'Are you sure want to cancel the subscription?'
    );
    if (isConfirmed) {
      //TODO:  API needs to added
    }
  };

  const handleCustomerConsole = () => {
    navigate('/CustomerConsole');
    setShowProfileMenu(false);
  };

  const handleSearchClick = () => {
    navigate('/Search');
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      profileMenuRef.current &&
      !profileMenuRef.current.contains(event.target as Node) &&
      profileIconRef.current &&
      !profileIconRef.current.contains(event.target as Node) &&
      profileImageRef.current &&
      !profileImageRef.current.contains(event.target as Node)
    ) {
      setShowProfileMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const userName = user.data?.user.name || '';
  const firstLetter = userName.charAt(0).toUpperCase();

  const avatarColor = getRandomColor(firstLetter);
  const profileImage = user.data?.user?.profileImage;

  return (
    <div>
      <header className='header'>
        <div className='inner-header'>
          <div className='header-comp'>
            <img
              src='/assets/logo_white_bg.jpg'
              alt='header-logo'
              style={{ height: 90, width: 90, objectFit: 'contain' }}
            />
            <nav className='nav'>
              <NavLink
                to='/'
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                Home
              </NavLink>
              <NavLink
                to='/Columns'
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                Columns
              </NavLink>
              <NavLink
                to='/Podcasts'
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                Podcasts
              </NavLink>
              <NavLink
                to='/SubscriptionPlans'
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                Subscribe
              </NavLink>
              <NavLink
                to='/AboutUs'
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                About Us
              </NavLink>
            </nav>
          </div>
          <div className='header-btn'>
            <img
              src='/assets/search.svg'
              alt='Search'
              className='search-icon'
              onClick={handleSearchClick}
            />
            {!isLoggedIn ? (
              <button
                className='trial-btn'
                onClick={() => handleLoginClick('register')}
              >
                Start Free Trial
              </button>
            ) : null}

            {!isLoggedIn ? (
              <button
                className='login-btn'
                onClick={() => handleLoginClick('login')}
              >
                Login
              </button>
            ) : (
              <div className='profile-container'>
                {profileImage ? (
                  <img
                    ref={profileImageRef}
                    src={profileImage}
                    alt='Profile'
                    className='profile-icon'
                    onClick={handleProfileClick}
                  />
                ) : (
                  <div
                    ref={profileIconRef}
                    className='profile-icon'
                    style={{ backgroundColor: avatarColor }}
                    onClick={handleProfileClick}
                  >
                    {firstLetter}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className='mobile-header'>
          <div
            className='hamburger'
            onClick={() => setShowHamBurgerMenu(!showHamBurgerMenu)}
          >
            <img
              src='/assets/burger-menu-left.svg'
              alt='Menu'
              style={{ height: 48, width: 48 }}
            />
          </div>
          <img
            src='/assets/logo_white_bg.jpg'
            alt='header-logo'
            style={{ height: 70, width: 70, objectFit: 'contain' }}
          />
          {!isLoggedIn ? (
            <button
              className='login-btn'
              onClick={() => handleLoginClick('login')}
            >
              Login
            </button>
          ) : (
            <div className='profile-container'>
              <img
                src='/assets/search.svg'
                alt='Search'
                className='search-icon'
                onClick={handleSearchClick}
              />
              {profileImage ? (
                <img
                  ref={profileImageRef}
                  src={profileImage}
                  alt='Profile'
                  className='profile-icon'
                  onClick={handleProfileClick}
                />
              ) : (
                <div
                  ref={profileIconRef}
                  className='profile-icon'
                  style={{ backgroundColor: avatarColor }}
                  onClick={handleProfileClick}
                >
                  {firstLetter}
                </div>
              )}
            </div>
          )}
          <nav className={`mobile-nav ${showHamBurgerMenu ? 'show' : ''}`}>
            <NavLink
              to='/'
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setShowHamBurgerMenu(!showHamBurgerMenu)}
            >
              Home
            </NavLink>
            <NavLink
              to='/Columns'
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setShowHamBurgerMenu(!showHamBurgerMenu)}
            >
              Columns
            </NavLink>
            <NavLink
              to='/Podcasts'
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setShowHamBurgerMenu(!showHamBurgerMenu)}
            >
              Podcasts
            </NavLink>
            <NavLink
              to='/SubscriptionPlans'
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setShowHamBurgerMenu(!showHamBurgerMenu)}
            >
              Subscribe
            </NavLink>
            <NavLink
              to='/AboutUs'
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setShowHamBurgerMenu(!showHamBurgerMenu)}
            >
              About Us
            </NavLink>
            <div
              className='mobile-header-menu-cross-icon'
              onClick={() => setShowHamBurgerMenu(!showHamBurgerMenu)}
            >
              X
            </div>
          </nav>
        </div>

        {showProfileMenu && (
          <ProfileMenu
            forwardRef={profileMenuRef}
            handleAdminConsole={handleAdminConsole}
            handleCustomerConsole={handleCustomerConsole}
            handleLogout={handleLogout}
            handleCancelSucription={handleCancelSucription}
          />
        )}

        {showLogin && (
          <LoginSignUpPopup
            onClose={handleCloseModal}
            showRegister={showRegister}
          />
        )}
      </header>
    </div>
  );
};

export default Header;
